import csiAction from "csi/action";
import Popup from "csi/action/Popup";
import { Context } from "csi/def/Context";
import Heading from "csi/def/Heading";
import ViewRef from "csi/def/ViewRef";
import RefContainer from "csi/heading/RefContainer";
import html from "csi/html";
import MaterialIcon from "csi/widget/MaterialIcon";
import declare from "dojo/_base/declare";
import _ from "lodash";

const CountriesOverViewTableRenderer = declare(RefContainer, {
	/**
     * @override
     * Renders top level table popup of compliance analysis results for each country 
     * within the analysis
     */
	toHtmlStatic(ctx: Context, h: Heading, refNode: HTMLElement) {
		const currentNode = ctx.getNode();
		const countries = currentNode?.Countries;
		const { view } = ctx;

		if (!_.isEmpty(countries)) {
			const refNodeDiv = html.create("div", {
				class: "csi-flex-row",
				style: "justify-content: space-between",
			}, refNode);

			refNode = html.create("span", null, refNodeDiv);

			this.inherited(arguments);

			refNode = html.create("span", null, refNodeDiv);
			
			new MaterialIcon({
				icon: "open_in_new",
				onClick: (): void => {
					const action = _.extend(new Popup(), {
						m_id: "ProductComplianceAnalysisPopup",
						m_viewRef: _.extend(new ViewRef(), {
							m_id: "CountriesPopupTable",
						}),
					});

					action.resolve();
					csiAction.invoke(view, refNode, action, {
						getTitle: () => h.getLabel(),
						onCreatePopupParams: (params) => _.extend(params),
					});
				},
			}).placeAt(refNode);
			return true;
		}
		return this.inherited(arguments);
	},
});

export = CountriesOverViewTableRenderer;
